import React from 'react';
import OdooSetup from '../../components/odoo-crm/OdooSetup';

const OdooIntegration = () => {
  return <OdooSetup />;
};

export default OdooIntegration;